import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { FilterKeyType } from '@ocean/types/dist/filter'
import { FilterUtils } from '@ocean/utils'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getListSimulatorTrainings } from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/api/simulatorListService'
import {
  SimulatorListFilterItem,
  SimulatorListFilterItems,
  SimulatorTraining,
} from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/types'
import { SimulatorListUtils } from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/utils'
import { SimulatorListState, ApiSimulatorListResponse } from './types'

const initialState: SimulatorListState = {
  simulatorTrainingListData: {},
  filters: {
    type: { keyType: FilterKeyType.Number },
  },
}

const simulatorListSlice = createSlice({
  name: 'simulatorTrainingInstructorILSimulatorList',
  initialState,
  reducers: {
    listSimulatorTrainingsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiSimulatorListResponse>>
    ) {
      state.simulatorTrainingListData = action.payload
    },
    setFilters(state, action: PayloadAction<SimulatorListFilterItem>) {
      const filter = state.filters[action.payload.name]
      if (filter) filter.value = action.payload.value
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { listSimulatorTrainingsLoaded, setFilters } = simulatorListSlice.actions
export { setFilters }
export default simulatorListSlice.reducer

export const getFilteredSimulatorList = createSelector(
  (simulators: SimulatorTraining[] = [], filters: SimulatorListFilterItems) => ({
    simulators,
    filters,
  }),
  ({ simulators, filters }) => FilterUtils.filterData(filters, simulators)
)

export const getSimulatorTypes = createSelector(
  (simulators: SimulatorTraining[] = []) => simulators,
  simulators => SimulatorListUtils.getSimulatorTypes(simulators)
)

export const getSimulatorItem = createSelector(
  (simulators: SimulatorTraining[] = [], trainingId: Guid) => ({ simulators, trainingId }),
  ({ simulators, trainingId }) => simulators.find(({ id }) => id === trainingId)
)

export const loadListSimulatorTrainingsData = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      list: getListSimulatorTrainings,
    },
    payloadAction: listSimulatorTrainingsLoaded,
  })
}
